import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Clients = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div>
      {/* Hero Section */}
      <div 
        className="relative h-80 bg-cover bg-center"
        style={{ backgroundImage: 'url(https://customer-assets.emergentagent.com/job_legacy-upgrade-6/artifacts/miafhfoc_Photo%20our%20clients.jpg)' }}
      >
        <div className="absolute inset-0 bg-slate-900 bg-opacity-60 flex items-center justify-center">
          {/* Logo Watermark */}
          <img 
            src="/logo.png" 
            alt="Target Health" 
            className="absolute bottom-6 left-6 w-40 opacity-20"
          />
          <h1 className="text-5xl font-bold text-white z-10">{t.clients.title}</h1>
        </div>
      </div>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-800 mb-2">
              {isRTL ? t.clients.mainTitle : 'TRUSTED BY LEADING'} <span className="text-cyan-500">{isRTL ? '' : 'HEALTHCARE ORGANIZATIONS'}</span>
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto mb-4"></div>
          </div>

          <div className="max-w-5xl mx-auto text-center py-20">
            <div className="bg-slate-50 rounded-lg p-16">
              <h3 className="text-6xl font-bold text-slate-300 mb-4">{t.clients.comingSoon}</h3>
              <p className="text-slate-600 text-lg">
                {t.clients.comingSoonText}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;